<div [formGroup]="form" fxLayout="column" fxLayoutGap="1rem">

  <div class="flex-wrap">
    <mat-form-field>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_ERSTMALIGER_INBETRIEBNAMEZEITPUNKT"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>erstmaliger Inbetriebnahmezeitpunkt</mat-label>
      <input formControlName="erstmaligerInbetriebnahmezeitpunkt"
        data-qa="erstmaligerInbetriebnahmezeitpunkt"
        [redispatchDisableControl]="disabled || readonly"
        [matDatepicker]="datepicker1"
        matInput
        name="betrieb_erstmaligerInbetriebnahmezeitpunkt"
        (focus)="datepicker1.open()"/>
      <mat-datepicker-toggle matSuffix [for]="datepicker1">
        <mat-icon matDatepickerToggleIcon svgIcon="innogy_picto_calendar-date-year"></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #datepicker1></mat-datepicker>
      @if (f.erstmaligerInbetriebnahmezeitpunkt.hasError('required')) {
        <mat-error>
          Bitte geben Sie den erstmaliger Inbetriebnahmezeitpunkt an.
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_KOMMERZIELLER_INBETRIEBNAMEZEITPUNKT"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>kommerzieller Inbetriebnahmezeitpunkt</mat-label>
      <input formControlName="kommerziellerInbetriebnahmezeitpunkt"
        data-qa="kommerziellerInbetriebnahmezeitpunkt"
        [redispatchDisableControl]="disabled || readonly"
        [matDatepicker]="datepicker2"
        matInput
        name="betrieb_kommerziellerInbetriebnahmezeitpunkt"
        (focus)="datepicker2.open()"/>
      <mat-datepicker-toggle matSuffix [for]="datepicker2">
        <mat-icon matDatepickerToggleIcon svgIcon="innogy_picto_calendar-date-year"></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #datepicker2></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="flex-wrap">
    <mat-form-field>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_STILLLEGUNGSZEITPUNKT_VORLAEUFIG"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Stilllegungszeitpunkt vorläufig</mat-label>
      <input formControlName="stilllegungszeitpunktVorlaeufig"
        data-qa="stilllegungszeitpunktVorlaeufig"
        [redispatchDisableControl]="disabled || readonly"
        [matDatepicker]="datepicker3"
        matInput
        name="betrieb_stilllegungszeitpunktVorlaeufig"
        (focus)="datepicker3.open()"/>
      <mat-datepicker-toggle matSuffix [for]="datepicker3">
        <mat-icon matDatepickerToggleIcon svgIcon="innogy_picto_calendar-date-year"></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #datepicker3></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_STILLLEGUNGSZEITPUNKT_ENDGUELTIG"
      [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
      <mat-label>Stilllegungszeitpunkt endgültig</mat-label>
      <input formControlName="stilllegungszeitpunktEndgueltig"
        data-qa="stilllegungszeitpunktEndgueltig"
        [redispatchDisableControl]="disabled || readonly"
        [matDatepicker]="datepicker4"
        matInput
        name="betrieb_stilllegungszeitpunktEndgueltig"
        (focus)="datepicker4.open()"/>
      <mat-datepicker-toggle matSuffix [for]="datepicker4">
        <mat-icon matDatepickerToggleIcon svgIcon="innogy_picto_calendar-date-year"></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #datepicker4></mat-datepicker>
    </mat-form-field>
  </div>
</div>
